import { useQuery } from '@tanstack/react-query'

import { Features } from '@/utils/featureFlag/features'

import { getFeatureFlags } from './userProfile.service'
import { setAuth0LoginEnabled } from '../domain/auth0'

export const useGetFeatureFlags = (names: string[], enabled: boolean) => {
  return useQuery({
    queryKey: ['getFeatureFlags', names],
    queryFn: async () => {
      const response = await getFeatureFlags(names)
      // saved to local storage so the unauthenticated /login route can read it
      setAuth0LoginEnabled(response.flags.find((flag) => flag.name === Features.AUTH0_LOGIN)?.enabled ?? false)
      return response
    },
    enabled,
    // 5 minutes so that it doesn't make a request every time the user navigates to a new page
    staleTime: 1000 * 60 * 5,
  })
}
